export default __webpack_public_path__ + "a745bf85bc88d91063ab7b232e249401.svg";